import { render, staticRenderFns } from "./PatientDetailAppeals.vue?vue&type=template&id=2c7838c9&scoped=true"
import script from "./PatientDetailAppeals.vue?vue&type=script&lang=js"
export * from "./PatientDetailAppeals.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailAppeals.vue?vue&type=style&index=0&id=2c7838c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7838c9",
  null
  
)

export default component.exports